import _ from 'underscore';
import React, {
  createRef, useCallback, useEffect, useMemo, useState,
} from 'react';
import { mergeClasses } from '@fluentui/react-components';

import { ToolsDialogConfig } from './types';
import { ToolsDialogContainer } from './tools-dialog-container';
import { ToolsContent } from './tools-content';
import { Searchbox, SearchboxLiveRegion } from './searchbox';
import { ToolsContentNoResults } from './tools-content-no-results';
import { getFilteredConfig, getResultsCount } from './utils';
import { useDialogStyles } from './styles';

export const ToolsDialog: React.FC<{
  config: ToolsDialogConfig;
  open: boolean;
  onClose: () => void;
}> = ({
  config, open, onClose,
}) => {
  const classes = useDialogStyles();

  const searchboxRef = createRef<HTMLInputElement>();
  const [searchValue, setSearchValue] = useState<string>('');

  useEffect(() => {
    if (open && searchboxRef.current) {
      searchboxRef.current.focus();
    }
  }, [open, searchboxRef]);

  const onSearchValueChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  }, []);

  const filteredConfig = useMemo(() => getFilteredConfig(config, searchValue), [config, searchValue]);
  const totalCount = useMemo(() => getResultsCount(filteredConfig), [filteredConfig]);

  return (
    <ToolsDialogContainer open={open} onClose={onClose}>
      <div className={mergeClasses('tools-dialog-content', classes.root)}>
        <Searchbox
          ref={searchboxRef}
          value={searchValue}
          onChange={onSearchValueChange}
        />
        <SearchboxLiveRegion count={totalCount} />
        {!_.isEmpty(filteredConfig.groups)
          ? (<ToolsContent config={filteredConfig} searchValue={searchValue} />)
          : (<ToolsContentNoResults />)}
      </div>
    </ToolsDialogContainer>
  );
};
